/**
 * 正则
 */

/**
 * 判断所有中日韩统一表意文字（包含简体、繁体中文）
 */
export const CHINESE_REG = /[\u4e00-\u9fa5]/;
